var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.375C12.2009 0.375 15.625 3.79911 15.625 8C15.625 12.2009 12.2009 15.625 8 15.625C3.79911 15.625 0.375 12.2009 0.375 8C0.375 3.79911 3.79911 0.375 8 0.375ZM12.0889 5.04688C11.7104 4.66857 11.0893 4.6685 10.7109 5.04688L6.86328 8.89355L5.28906 7.31836C4.91072 6.94033 4.28952 6.9404 3.91113 7.31836C3.53269 7.69681 3.53269 8.31882 3.91113 8.69727L6.1748 10.9609C6.35633 11.1425 6.60367 11.2471 6.86426 11.2471C7.1247 11.247 7.37128 11.1423 7.55273 10.9609L12.0889 6.4248L12.0938 6.4209C12.4638 6.03806 12.4697 5.42775 12.0889 5.04688Z",
    fill: "#3C81FB",
    stroke: "#3C81FB",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedChecked);
export default __webpack_public_path__ + "static/media/roundedChecked.e1adc286423f1605213b1d2eda3d530f.svg";
export { ForwardRef as ReactComponent };